module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0035.jpg?v=49130334";